import { Dialog } from 'primereact/dialog';
import { useEffect, useState } from 'react';
import { obtenerCustodiaTrazabilidad } from '../../services/Custodia/CustodiaService';
import { Image } from 'primereact/image';
import { Button } from 'primereact/button';

export const CustodiaTrazabilidad = ({ custodiaSeleccionada, onHide }) => {
    const [trazabilidadData, setTrazabilidadData] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadTrazabilidadData = async (custodiaId) => {
        // Lógica para cargar la trazabilidad de la custodia seleccionada
        try {
            setLoading(true);
            const response = await obtenerCustodiaTrazabilidad(custodiaId);
            setTrazabilidadData(response.data);
        } catch (error) {
            console.error('Error loading custodia trazabilidad data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (custodiaSeleccionada) {
            loadTrazabilidadData(custodiaSeleccionada.id);
        }

        return () => {
            setTrazabilidadData([]);
        };
    }, [custodiaSeleccionada]);

    return (
        <Dialog header="Trazabilidad historia" visible={!!custodiaSeleccionada} onHide={onHide} className="w-full md:w-9 lg:w-4">
            {loading ? (
                <p>Cargando...</p>
            ) : (
                /* imagen a la izquierda y descripción a a derecha */
                <div>
                    {trazabilidadData.length === 0 ? (
                        <p>No hay datos de trazabilidad disponibles.</p>
                    ) : (
                        trazabilidadData.map((item) => (
                            <div key={item.id} className="flex flex-col md:flex-row items-center gap-4 border rounded-xl shadow-sm bg-white mb-4">
                                {/* Imagen */}
                                <div className="flex-shrink-0">
                                    <Image src={`data:image/jpg;base64,${item.imagen}`} zoomSrc={`data:image/jpg;base64,${item.imagen}`} alt="Imagen" width="150" height="150" preview />
                                </div>

                                {/* Texto */}
                                <div className="flex flex-column w-full md:w-auto">
                                    <p className="text-gray-800 mb-2 text-sm md:text-base">{item.descripcion}</p>

                                    <div className="flex flex-row items-center flex-wrap gap-3 text-sm">
                                        <span className="font-medium text-gray-700">Fecha:</span>
                                        <span className="text-gray-600">{item.fechaCreacion || 'N/A'}</span>

                                        <Button
                                            label="Ver ubicación"
                                            icon="pi pi-map-marker"
                                            className="p-button-sm p-button-text text-blue-700 hover:text-blue-900"
                                            onClick={() => window.open(`https://www.google.com/maps?q=${item.latitud},${item.longitud}`, '_blank')}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </Dialog>
    );
};
